import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import {FlowView} from '../flows/FlowView.react';
import * as BrowserPermission from "../BrowserPermission";
import * as Permission from '../../common/util/Permission';
import { User } from '../../common/types/types';

interface OrganisationBillingProps {
 intl: IntlShape;
 relay?: object;
 user: User;
}

class OrganisationBilling extends React.Component<OrganisationBillingProps> {

    typeName = 'organisations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

    }

    render() {
        const data = this.props.user.organisation;
        let list = data.billingItems;

        const hasBilling = BrowserPermission.hasPermission(Permission.PERM_INSTANCE_BILLING) && BrowserPermission.developerModeEnabled();
        let columns = {
            'flow.name': {
                link: false,
            },
            'periodStart': {
                link: false,
            },
            'periodEnd': {
                link: false,
            },
            'billedValue': {
                link: false,
            },
            'billedPrice': {
                link: false,
            },
            'billedText': {
                link: false,
            },
            'shouldBilled': {
                link: false,
                render: (column, item, url, columnMapping) => {
                    if (item.isBilled) {
                        if (item.invoiceNo) {
                            return <strong>{item.invoiceNo}</strong>;
                        } else {
                            return (
                                <strong><FormattedMessage
                                defaultMessage="Billed"
                                id="organisationBilling.billed"/></strong>
                            );
                        }
                    } else if (item.shouldBilled) {
                        return (
                            <i><FormattedMessage
                            defaultMessage="Will be billed"
                            id="organisationBilling.shouldBilled"/></i>
                        );
                    }
                    return "-";
                },
            },
        };

        if (hasBilling) {
            columns['flow.flowDef.name'] = {
                link: false,
            };
            columns['billedNote'] = {
                link: false,
            };

            columns['flow.billingStatus'] = {
                link: false,
                render: (column, item, url, columnMapping) => {
                    if (item && item.flow) {
                        return (FlowView.getBillingStatus(item.flow, this.props.intl));
                    }
                },
            };
        }

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } className="organisationView">

                <PagingGrid
                        columns={columns}
                        edges={list}
                        metadata={types['billingItems']}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        renderLink={false}
                        urlMapping={urlMapping} />

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(OrganisationBilling), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        first: defaultPageSize,
        after: null,
        organisationId: '',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                featureFlags,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    description,
                    featureFlags,
                    billingItems(first: $first, after: $after) {
                        edges {
                            node {
                                id,
                                flow {
                                    id,
                                    realId,
                                    organisation_id,
                                    instance_id,
                                    name,
                                    billingStatus,
                                    flowDef {
                                        id,
                                        realId,
                                        name,
                                        title,
                                    },
                                },
                                period,
                                periodStart,
                                periodEnd,
                                billedValue,
                                billedText,
                                billedNote,
                                billedPrice,
                                shouldBilled,
                                isBilled,
                                invoiceNo,
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    },
                }
            }
        `,
    },
});
